import { Injectable } from '@angular/core';
import Radar from 'radar-sdk-js';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeofenceService {

  constructor() { }
  public initialize() {
    Radar.initialize(environment.RADAR.API_KEY);
  }
  public setUserId(userId: string) {
    Radar.setUserId(userId);
  }
  public trackOnce(callback): Promise<any> {
    return Radar.trackOnce(callback);
  }
  public isUserInGeofence(tag: string, externalId: string): Promise<boolean> {
    return Radar.trackOnce().then(success => 
      success?.user?.geofences?.some(g => g?.tag == tag && g?.externalId == externalId)
    , failure=> false);
  }
}